// Reference: https://www.easypost.com/service-levels-and-parcels
// Keys must align exactly with the "Service Levels" EasyPost provides ^.
// Values are whatever pretty string we want to display to the user.
export const FEDEX_SERVICE_LEVELS = {
  FEDEX_GROUND: 'Ground',
  FEDEX_2_DAY: '2 Day',
  FEDEX_2_DAY_AM: '2 Day (AM)',
  FEDEX_EXPRESS_SAVER: 'Express Saver',
  STANDARD_OVERNIGHT: 'Standard Overnight',
  FIRST_OVERNIGHT: 'First Overnight',
  PRIORITY_OVERNIGHT: 'Priority Overnight',
  INTERNATIONAL_ECONOMY: 'International Economy',
  INTERNATIONAL_FIRST: 'International First',
  FEDEX_INTERNATIONAL_CONNECT_PLUS: 'International Connect Plus',
  FEDEX_INTERNATIONAL_PRIORITY: 'International Priority',
  FEDEX_INTERNATIONAL_PRIORITY_EXPRESS: 'International Priority Express',
  GROUND_HOME_DELIVERY: 'Ground Home Delivery'
  // SMART_POST: 'Smart Post' // though the EP documentation mentions this under FedEx, we confirmed via email and production data that it shouldn't be there
}

export const FEDEX_SMARTPOST_SERVICE_LEVELS = {
  SMART_POST: 'Ground Economy (SmartPost)'
}

export const UPS_SERVICE_LEVELS = {
  Ground: 'Ground',
  UPSGroundsaverGreaterThan1lb: 'Ground Saver (>1lb)',
  UPSStandard: 'Standard',
  UPSSaver: 'UPSSaver',
  Express: 'Express',
  ExpressPlus: 'Express Plus',
  Expedited: 'Expedited',
  NextDayAir: 'Next Day Air',
  NextDayAirSaver: 'Next Day Air Saver',
  NextDayAirEarlyAM: 'Next Day Air (Early AM)',
  '2ndDayAir': '2nd Day Air',
  '2ndDayAirAM': '2nd Day Air (AM)',
  '3DaySelect': '3-Day Select'
}

export const UPS_MI_SERVICE_LEVELS = {
  // Partial carrier name included to help differentiate from vanilla UPS
  First: 'Mail Innovations First Class',
  Priority: 'Mail Innovations Priority',
  ExpeditedMailInnovations: 'Mail Innovations Expedited',
  PriorityMailInnovations: 'Mail Innovations Priority (International)',
  EconomyMailInnovations: 'Mail Innovations Economy (International)'
}

export const UPS_SUREPOST_SERVICE_LEVELS = {
  SurePostUnder1Lb: 'SurePost Under 1 Lb',
  SurePostOver1Lb: 'SurePost Over 1 Lb'
}

export const USPS_SERVICE_LEVELS = {
  First: 'First',
  Priority: 'Priority',
  Express: 'Express',
  ParcelSelect: 'Parcel Select',
  LibraryMail: 'Library Mail',
  MediaMail: 'Media Mail',
  FirstClassMailInternational: 'First Class Mail (International)',
  FirstClassPackageInternationalService: 'First Class Package (International)',
  PriorityMailInternational: 'Priority Mail (International)',
  ExpressMailInternational: 'Express Mail (International)',
  GroundAdvantage: 'Ground Advantage'
}

export const CANADA_POST_SERVICE_LEVELS = {
  RegularParcel: 'Regular Parcel',
  Priority: 'Priority',
  Xpresspost: 'Xpresspost',
  ExpeditedParcel: 'Expedited Parcel',
  XpresspostCertified: 'Xpresspost Certified',
  LibraryBooks: 'Library Books',
  ExpeditedParcelUSA: 'Expedited Parcel USA',
  PriorityWorldwideEnvelopeUSA: 'Priority Worldwide Envelope USA',
  PriorityWorldwidePakUSA: 'Priority Worldwide Pak USA',
  PriorityWorldwideParcelUSA: 'Priority Worldwide Parcel USA',
  SmallPacketUSAAir: 'Small Packet USA Air',
  TrackedPacketUSA: 'Tracked Packet USA',
  TrackedPacketUSALVM: 'Tracked Packet USA LVM',
  XpresspostUSA: 'Xpresspost USA',
  XpresspostInternational: 'Xpresspost International',
  InternationalParcelAir: 'International Parcel Air',
  InternationalParcelSurface: 'International Parcel Surface',
  PriorityWorldwideEnvelopeIntl: 'Priority Worldwide Envelope Intl',
  PriorityWorldwidePakIntl: 'Priority Worldwide Pak Intl',
  PriorityWorldwideParcelIntl: 'Priority Worldwide Parcel Intl',
  SmallPacketInternationalAir: 'Small Packet International Air',
  SmallPacketInternationalSurface: 'Small Packet International Surface',
  TrackedPacketInternational: 'Tracked Packet International'
}

const serviceMap = {
  ...FEDEX_SERVICE_LEVELS,
  ...FEDEX_SMARTPOST_SERVICE_LEVELS,
  ...UPS_SERVICE_LEVELS,
  ...UPS_MI_SERVICE_LEVELS,
  ...USPS_SERVICE_LEVELS,
  ...CANADA_POST_SERVICE_LEVELS
}

const approximateServiceName = serviceDictionary => service => serviceDictionary[service] || service

export const serviceByCarrier = (carrier, service) => {
  const servicesByCarrier = {
    UPS: UPS_SERVICE_LEVELS,
    UPSDAP: UPS_SERVICE_LEVELS,
    UPSMailInnovations: UPS_MI_SERVICE_LEVELS,
    UPSSurePost: UPS_SUREPOST_SERVICE_LEVELS,
    FedEx: FEDEX_SERVICE_LEVELS,
    FedExDefault: FEDEX_SERVICE_LEVELS,
    FedExSmartPost: FEDEX_SMARTPOST_SERVICE_LEVELS,
    USPS: USPS_SERVICE_LEVELS,
    'USPS Ship': USPS_SERVICE_LEVELS,
    CanadaPost: CANADA_POST_SERVICE_LEVELS
  }[carrier]
  return approximateServiceName(servicesByCarrier || {})(service)
}

export default approximateServiceName(serviceMap)
